module.exports = __webpack_public_path__ + "static/media/pexels-photo-7245469.be97db61.jpeg";